import React from 'react';
export function Footer() {
  return <>
      {/* Final CTA Section */}
      <section className="w-full bg-primary py-20 px-4 text-center" data-id="element-85">
        <div className="max-w-3xl mx-auto" data-id="element-86">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-white mb-8" data-id="element-87">
            Récupérez votre temps aujourd'hui.
          </h2>
          <a href="https://eps-pret-a-l-emploi.impultienda.ar/checkout" className="inline-flex items-center justify-center gap-2 bg-white text-primary font-bold text-lg sm:text-xl px-10 py-4 rounded-2xl hover:bg-bg-main transition-colors shadow-lg" data-id="element-88">
            <span aria-hidden="true" data-id="element-89">🚀</span>
            ACCÉDER À LA COLLECTION COMPLÈTE
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-[#1A1A1A] py-12 px-4" data-id="element-90">
        <div className="max-w-4xl mx-auto text-center" data-id="element-91">
          <div className="text-white text-2xl font-serif font-black tracking-widest mb-6 flex items-center justify-center gap-2" data-id="element-92">
            <span data-id="element-93">⚽</span> EDULABS — EPS PRÊT-À-L'EMPLOI
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-sm text-white/70 mb-8" data-id="element-94">
            <a href="#" className="hover:text-white transition-colors" data-id="element-95">
              Mentions Légales
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-96">
              Politique de Confidentialité
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-97">
              Contact
            </a>
          </div>

          <p className="text-white/40 text-xs" data-id="element-98">
            © {new Date().getFullYear()} EDULABS — EPS PRÊT-À-L'EMPLOI. Tous
            droits réservés.
          </p>
        </div>
      </footer>
    </>;
}